module.exports = __webpack_public_path__ + "img/groupMap.fc051a75.png";